import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Button from "../components/common/Button";
import Card from "../components/common/Card";
import SecurityTrustNotice from "../components/common/SecurityTrustNotice";
import { useAuth } from "../contexts/AuthContext";

export default function LoginPage() {
  const { user, loginUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setError("");
  }, [form.email, form.password]);

  if (user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginUser(form.email, form.password);
      navigate("/dashboard");
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page page-enter">
      <Card style={{ width: "min(420px, 100%)" }}>
        <h1 className="h1" style={{ marginBottom: 18 }}>
          Sign In
        </h1>
        <form onSubmit={onSubmit}>
          <div className="form-row">
            <label>Email Address</label>
            <input type="email" required value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
          </div>
          <div className="form-row">
            <label>Password</label>
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
            />
          </div>
          {error ? <div className="error-text">{error}</div> : null}
          <Button className="full-width" type="submit" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? "Signing In..." : "Sign In"}
          </Button>
        </form>
        <p className="muted" style={{ marginTop: 14 }}>
          Don't have an account? <Link to="/signup">Create one</Link>
        </p>
      </Card>
      <SecurityTrustNotice />
    </div>
  );
}
